
import actions from "./actions"
import mutations from "./mutations"

export default  {
    namespaced: true,

    state: () => ({ 
        layout: 'app',
        isShowAddOrUpdateModal: false,
        categoriesList:[
            {
                group_name: 'Certification',
                list: [{id: 1,  name: 'Solution Archetict' }, {id: 2, name: 'Developer Associate' }, {id: 3, name: 'K8s' }],
            },
            {
                group_name: 'Event',
                list: [{ id: 1, name: 'Mango\'s Day' }, { id: 2,name: 'Annaual' }, { id: 3, name: 'Ramazan Event' }],
            },
            {
                group_name: 'Celebration',
                list: [{ id: 1,name: 'Engagement' }, { id: 2,name: 'Marriage' }, { id: 3,name: 'Baby Birth' }],
            },
        ],
        employeeList:[
            {
                group_name: 'Admin',
                list: [{ id: 1, name: 'Rashid' }, { id: 2, name: 'Hamyon' }, {id: 3, name: 'Wajahat' }, { id: 5, name: 'Bilal' }],
            },
            {
                group_name: 'Lead',
                list: [{ id: 1, name: 'Raza' }, {id: 2, name: 'Waqar' }, { id: 4,name: 'Razaq' }],
            },
            {
                group_name: 'Employee',
                list: [{ id: 1, name: 'Umair Younus' }, {id: 2, name: 'Suliman Ali' }, { id: 4,name: 'Hasnain' }],
            },
        ],

        jobTitlestableColumns: ['id', 'title','description', 'action'],
        jobTitlesList: [
            {id: "1", title: "Django Engineer", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "2", title: "MERN Engineer", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "3", title: "DevOps Engineer", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "4", title: "Backend Engineer", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "5", title: "Frontend Engineer", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "6", title: "SRE Engineer", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "7", title: "Vue Engineer", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "8", title: "React Engineer", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
        ],

        jobPrefixestableColumns: ['id', 'title','description', 'action'],
        jobPrefixes:[
            {id: "1", title: "Senior", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "2", title: "Junior", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "3", title: "Lead", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "4", title: "Archetict", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "5", title: "Director", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "6", title: "Associate", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
            {id: "7", title: "Professinal", description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
        ],
        teamsList: [
            {
                id: 1,
                title: 'Murthey',
                description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
                shift: {id: 1, name: "Day", start_from: "11 AM", end_at: "08 PM"},
                tasks: [
                    { task_id: 1, title: 'Agha Ramees Khan', description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.', image: true, date: ' 08 Aug, 2020',
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "Angular Engineer"}
                    },
                    { task_id: 2, title: 'Waqar Murtaza', description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.', date: ' 09 Aug, 2020',
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "K8s Engineer"}
                    },
                    { task_id: 3, title: 'Suliman Ali', description: ' ', date: ' 08 Aug, 2020',
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "React Engineer"}
                    },
                    { task_id: 4, title: 'Hassan Zia', description: ' ', date: ' 08 Aug, 2020',
                        jobPrefix: {id: 1, title: "Junir"},
                        jobTitle: {id: 1, title: "Django Engineer"}
                    },
                    { task_id: 5, title: 'Umair Younus', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
                    { task_id: 1, title: 'Wasim Ahmad', description: ' ', date: ' 08 Aug, 2020'  ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 4, title: "Full Stack Engineer"}
                    },
                    { task_id: 2, title: 'Ammar Bin Rizwan ',description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', date: ' 09 Aug, 2020',
                        jobPrefix: {id: 3, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
                ],
            },
            {
                id: 2,
                title: 'Mohammad Raza Dev',
                description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
                shift: {id: 1, name: "Night", start_from: "9 PM", end_at: "06 AM"},
                tasks: [
                    { task_id: 1, title: 'Wasim Ahmad', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "React Engineer"}
                        },
                    {task_id: 2,title: 'Ammar Bin Rizwan ',description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',date: ' 09 Aug, 2020',
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "React Engineer"}
                    },
                    { task_id: 3, title: 'Suliman Ali', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "React Engineer"}
                        },
                    { task_id: 4, title: 'Hassan Zia', description: ' ', date: ' 08 Aug, 2020',
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "React Engineer"}
                        },
                ],
            },
            {
                id: 4,
                title: 'MustScaleUp',
                description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
                shift: {id: 1, name: "Mid Day", start_from: "2 PM", end_at: "10 AM"},
                tasks: [
                    { task_id: 1, title: 'Wasim Ahmad', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "React Engineer"}
                        },
                    { task_id: 2, title: 'Ammar Bin Rizwan ',description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', date: ' 09 Aug, 2020',
                    jobPrefix: {id: 1, title: "Senior"},
                    jobTitle: {id: 1, title: "React Engineer"}
                    },
                    { task_id: 4, title: 'Hassan Zia', description: ' ', date: ' 08 Aug, 2020' ,
                    jobPrefix: {id: 1, title: "Senior"},
                    jobTitle: {id: 1, title: "React Engineer"}
                    },
                ],
            },
            {
                id: 5,
                title: 'SQA',
                description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
                shift: {id: 1, name: "Day", start_from: "11 AM", end_at: "08 PM"},
                tasks: [
                    { task_id: 1, title: 'Wasim Ahmad', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "Full Stack Engineer"}
                    },
                    { task_id: 2,title: 'Ammar Bin Rizwan ',description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',date: ' 09 Aug, 2020',
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
                    { task_id: 3, title: 'Suliman Ali', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "React Engineer"}
                    },
                    { task_id: 4, title: 'Hassan Zia', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Junior"},
                        jobTitle: {id: 1, title: "Django Engineer"}
                    },
                    { task_id: 5, title: 'Umair Younus', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
                    { task_id: 1, title: 'Zia', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "K8s Engineer"}
                    },
                    { task_id: 2, title: 'Sikandar',description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', date: ' 09 Aug, 2020',
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
               
                ],
            },
            {
                id: 2,
                title: 'Mohammad Raza Dev',
                description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
                shift: {id: 1, name: "Day", start_from: "11 AM", end_at: "8 AM"},
                tasks: [
                    { task_id: 1, title: 'Wasim Ahmad', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "Full Stack Engineer"}
                    },
                    {task_id: 2, title: 'Ammar Bin Rizwan ',description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',date: ' 09 Aug, 2020',
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
                ],
            },
            {
                id: 4,
                title: 'MustScaleUp',
                description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
                shift: {id: 1, name: "Night", start_from: "9 PM", end_at: "06 AM"},
                tasks: [
                    { task_id: 1, title: 'Wasim Ahmad', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "Full Stack Engineer"}
                    },
                    { task_id: 2, title: 'Ammar Bin Rizwan ', description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', date: ' 09 Aug, 2020',
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
                ],
            },
            {
                id: 6,
                title: 'HR',
                description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
                shift: {id: 1, name: "Day", start_from: "11 AM", end_at: "8 AM"},
                tasks: [
                    { task_id: 1, title: 'Wasim Ahmad', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "Full Stack Engineer"}
                    },
                    {task_id: 2,title: 'Ammar Bin Rizwan ',description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',date: ' 09 Aug, 2020',
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
                    { task_id: 3, title: 'Suliman Ali', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "React Engineer"}
                    },
                    { task_id: 4, title: 'Hassan Zia', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Junior"},
                        jobTitle: {id: 1, title: "Django Engineer"}
                    },
                    { task_id: 5, title: 'Umair Younus', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
                    { task_id: 1, title: 'Wasim Ahmad', description: ' ', date: ' 08 Aug, 2020' ,
                        jobPrefix: {id: 1, title: "Senior"},
                        jobTitle: {id: 1, title: "Full Stack Engineer"}
                    },
                    { task_id: 2, title: 'Ammar Bin Rizwan ',description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', date: ' 09 Aug, 2020',
                        jobPrefix: {id: 1, title: "Associate"},
                        jobTitle: {id: 1, title: "DevOps Engineer"}
                    },
               
                ],
            },
            { id: 3, title: 'New', description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.', 
            shift: {id: 1, name: "Day", start_from: "11 AM", end_at: "8 AM"}, 
            tasks: [],},
        ],
     }),

    mutations: mutations,
    actions: actions,
    getters: { 
        isShowModal(state) {
            return state.isShowAddOrUpdateModal;
        },
     }
  }
